var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEquipmentFul(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.1556 1.38085C15.504 1.15686 15.6049 0.692829 15.3809 0.344401C15.1569 -0.00402644 14.6929 -0.104904 14.3444 0.119085L0.344432 9.11909C0.129765 9.25709 0 9.49477 0 9.74997V16.75C0 18.5449 1.45507 20 3.25 20H16.75C18.5449 20 20 18.5449 20 16.75V9.74997C20 9.33576 19.6642 8.99997 19.25 8.99997H19V5.74997C19 4.78347 18.2165 3.99997 17.25 3.99997H14.25C13.2835 3.99997 12.5 4.78347 12.5 5.74997V6.49997H9.25C8.2835 6.49997 7.5 7.28347 7.5 8.24997V8.99997H3.30361L15.1556 1.38085ZM12.5 7.99997V8.99997H9V8.24997C9 8.1119 9.11193 7.99997 9.25 7.99997H12.5ZM17.5 8.99997H14V5.74997C14 5.6119 14.1119 5.49997 14.25 5.49997H17.25C17.3881 5.49997 17.5 5.6119 17.5 5.74997V8.99997Z",
    fill: "#212121"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEquipmentFul);
export default __webpack_public_path__ + "static/media/equipment-ful.2ea9abc119e16550c49de5db2882ccf6.svg";
export { ForwardRef as ReactComponent };